import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
const apiDomain = process.env.REACT_APP_API_DOMAIN;
const authDomain = process.env.REACT_APP_AUTH_DOMAIN;
export const FbCallbackHandler = () => {
  const [authResult, setAuthResult] = useState(null);
  const [error, setError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuth = async () => {
      try {
        const queryParams = new URLSearchParams(location.search);
        const accessToken = queryParams.get('access_token');
        
        console.log("[fbCallbackHandler] Access Token:", accessToken ? "Present" : "Missing");
        
        if (!accessToken) {
          console.error("[fbCallbackHandler] No access token in URL");
          setError(new Error("No access token received"));
          setIsProcessing(false);
          return;
        }

        const res = await fetch(`${authDomain}/auth/validate?access_token=${accessToken}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
        });
        
        console.log("[fbCallbackHandler] Validation Response:", res.status);
        
        if (!res.ok) {
          console.error("[fbCallbackHandler] Validation failed:", res.status);
          setError(new Error("Token validation failed"));
          setIsProcessing(false);
          return;
        }
        
        const result = await res.json();
        console.log("[fbCallbackHandler] Auth Result:", result);
        
        setAuthResult(result);
        
        // Set cookies with 7 days expiry (matching Login.js)
        Cookies.set('fbauthToken', accessToken, { expires: 7, path: '/' });
        Cookies.set('userId', result.userId, { expires: 7, path: '/' });
        Cookies.set('authToken', 'fbAuthToken', { expires: 7, path: '/' });
        Cookies.set('loginTime', Date.now().toString(), { expires: 7, path: '/' });

        // Set localStorage for faster future auth checks
        localStorage.setItem("isAuthenticated", "true");

        console.log("[fbCallbackHandler] Cookies set, redirecting to /");
        
        // Use navigate for SPA routing
        navigate("/", { replace: true });
      } catch (error) {
        console.error("[fbCallbackHandler] Error:", error);
        setError(error);
        setIsProcessing(false);
      }
    };

    handleAuth();
  }, [location, navigate]);

  if (error) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-red-50 via-white to-red-50">
        <div className="text-center">
          <div className="text-red-500 text-6xl mb-4">✕</div>
          <h1 className="text-2xl font-bold text-red-600 mb-2">Authentication Failed</h1>
          <p className="text-gray-600 mb-4">{error.message}</p>
          <button 
            onClick={() => navigate("/admin/login", { replace: true })}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  if (isProcessing) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg font-medium">Completing authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center">
      <div className="text-center">
        <h1>Authentication Successful</h1>
        <p>Welcome, User {authResult.userId}!</p>
      </div>
    </div>
  );
};


// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { consumeTicketFromURL } from "./hadelFunction";

// export const FbCallbackHandler = () => {
//   const [status, setStatus] = useState("idle");
//   const navigate = useNavigate(); // Use React Router's navigate for redirecting

//   useEffect(() => {
//     const handleAuth = async () => {
//       const ok = await consumeTicketFromURL(); // consume the ticket silently
//       setStatus(ok ? "ok" : "err");

//       if (ok) {
//         // After the ticket is consumed, redirect to the dashboard page
//         navigate("/dashboard"); // Redirect to the dashboard after successful login
//       } else {
//         // If the ticket consumption fails, redirect to login
//         console.error("Ticket consumption failed, redirecting to login");
//         navigate("/admin/login");
//       }
//     };

//     handleAuth(); // Run the handleAuth function on load
//   }, [navigate]);

//   return (
//     <div style={{ padding: 24 }}>
//       {status === "err" ? "Authentication failed. Check console." : "Finalizing sign-in…"}
//     </div>
//   );
// };



